/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function SetteiTab(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        text: {},
        SetteiTab: { backgroundColor: "rgba(210,210,210,1)" },
      },
      variantValues: { situation: "default" },
    },
    {
      overrides: { text: {}, SetteiTab: {} },
      variantValues: { situation: "select" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="10px"
      direction="row"
      width="176px"
      height="unset"
      justifyContent="center"
      alignItems="center"
      position="relative"
      borderRadius="8px 8px 0px 0px"
      padding="16px 24px 16px 24px"
      backgroundColor="rgba(255,255,255,1)"
      display="flex"
      {...rest}
      {...getOverrideProps(overrides, "SetteiTab")}
    >
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="700"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        textAlign="left"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="0.65px"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="全拠点"
        {...getOverrideProps(overrides, "text")}
      ></Text>
    </Flex>
  );
}
